import ScrollHint from "scroll-hint";

document.addEventListener("DOMContentLoaded", () => {
  new ScrollHint('.js-scrollable', {
    // suggestiveShadow: true,
    i18n: {
      scrollable: 'スクロールできます',
    }
  });
});

